import { DropdownMenuProps } from 'core/dropdown/dropdown-menu.props';
import { StyledDropdownMenuContainer } from 'core/dropdown/dropdown.styles';

export const DropdownMenu = ({ children, width }: DropdownMenuProps) => (
  <StyledDropdownMenuContainer width={width}>
    {children}
  </StyledDropdownMenuContainer>
);
